import dayjs from 'dayjs';

// Estado con el que el backend guarda una pregunta que falló -> tipo de error que entiende `errorAdvice`.
const STATUS_TO_KIND = {
  INVALID_KEY: 'INVALID_KEY',
  UNAVAILABLE: 'PROVIDER_UNAVAILABLE',
  RATE_LIMITED: 'RATE_LIMITED',
  TIMEOUT: 'TIMEOUT',
  REJECTED: 'PROVIDER_REJECTED',
};

/**
 * Convierte los mensajes guardados de un chat (`{ question, answer, status, errorMessage }`) en los del chat en pantalla.
 * Una pregunta que falló vuelve como error, con su motivo, y se puede reintentar.
 */
export const restoreMessages = (saved = []) =>
  saved.flatMap((item) => [
    { role: 'user', text: item.question },
    item.answer
      ? { role: 'assistant', text: item.answer, completed: item.status === 'OK' }
      : {
        role: 'assistant',
        isError: true,
        question: item.question,
        kind: STATUS_TO_KIND[item.status] || null,
        text: item.errorMessage || 'No se pudo completar la consulta.',
      },
  ]);

/** Cuándo fue la última actividad de un chat, en pocas palabras: "hoy 14:32", "ayer", "27/10". */
export const formatActivity = (iso, now = dayjs()) => {
  const date = dayjs(iso);
  if (!date.isValid()) return '';
  if (date.isSame(now, 'day')) return `hoy ${date.format('HH:mm')}`;
  if (date.isSame(now.subtract(1, 'day'), 'day')) return 'ayer';
  return date.isSame(now, 'year') ? date.format('DD/MM') : date.format('DD/MM/YYYY');
};
